import * as React from "react";
import { Card } from "azure-devops-ui/Card";

const stats = [
    {
        label: "Points",
        value: 340
    },
    {
        label: "3PM",
        value: 23
    },
    {
        label: "Rebounds",
        value: 203
    },
    {
        label: "Assists",
        value: 290
    },
    {
        label: "Steals",
        value: 56
    }
];

export default class CardExample extends React.Component {
    public render(): JSX.Element {
        return (
            <Card className="flex-grow" titleProps={{ text: "Will Orta 2018-2019 🏀", ariaLevel: 3 }}>
                <div className="flex-row" style={{ flexWrap: "wrap" }}>
                    {stats.map((items, index) => (
                        <div className="flex-column" style={{ minWidth: "120px" }} key={index}>
                            <div className="body-m secondary-text">{items.label}</div>
                            <div className="body-m primary-text">{items.value}</div>
                        </div>
                    ))}
                </div>
            </Card>
        );
    }
}
